var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrintMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39,10h-3V4c0-1.1025391-0.8974609-2-2-2H14c-1.1025391,0-2,0.8974609-2,2v6H9c-2.7568359,0-5,2.2431641-5,5v14 c0,2.7568359,2.2431641,5,5,5h3v10c0,1.1025391,0.8974609,2,2,2h20c1.1025391,0,2-0.8974609,2-2V34h3c2.7568359,0,5-2.2431641,5-5 V15C44,12.2431641,41.7568359,10,39,10z M14,4h20v6H14V4z M14,44V28h20l0.0019531,16H14z M42,29c0,1.6542969-1.3457031,3-3,3h-3v-4 h2v-2H10v2h2v4H9c-1.6542969,0-3-1.3457031-3-3V15c0-1.6542969,1.3457031-3,3-3h30c1.6542969,0,3,1.3457031,3,3V29z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 32,
    width: 12,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 38,
    width: 12,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 16,
    width: 4,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintMedium);
export default __webpack_public_path__ + "static/media/print--medium.dd4b1636d94fefa46e486ef9ae0a0086.svg";
export { ForwardRef as ReactComponent };